import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { getConsent, setConsent } from "../lib/pixel";

export const ConsentBanner = () => {
  const [open, setOpen] = useState(false);
  useEffect(() => { setOpen(!getConsent()); }, []);

  const choose = (v) => { setConsent(v); setOpen(false); };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ y: 40, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 40, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-4 inset-x-4 sm:inset-x-auto sm:right-6 sm:bottom-6 sm:max-w-md z-[60] bg-ink text-bone p-6 shadow-2xl"
          role="dialog"
          aria-label="Cookie and tracking consent"
          data-testid="consent-banner"
        >
          <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-bone/50">Privacy</p>
          <p className="mt-3 text-sm leading-relaxed text-bone/85">
            We use the Meta Pixel to measure page views and completed quote requests so we can understand how people find us. No names, contact details, form text or photos are shared. See our{" "}
            <Link to="/privacy" className="underline underline-offset-4 hover:text-teal transition-colors" data-testid="consent-privacy-link">privacy notice</Link>.
          </p>
          <div className="mt-5 flex gap-2">
            <button onClick={() => choose("granted")} data-testid="consent-accept-btn" className="flex-1 bg-bone text-ink font-display font-medium text-sm px-4 py-3 hover:bg-teal hover:text-bone transition-colors duration-300">
              Accept
            </button>
            <button onClick={() => choose("denied")} data-testid="consent-decline-btn" className="flex-1 border border-bone/30 text-bone font-display font-medium text-sm px-4 py-3 hover:border-bone transition-colors duration-300">
              Decline
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
